const zh = {
	home: {
		slogan: '小心科技为远程心电遥测研制独特的ECG传感器及心律和心率变异性解析',
		home_title: '手持和贴片式心律监测传感器，专为远程看护心脏而设计',
		CB11_title: 'CB11',
		CB11_highlight_1: '轻巧依从，简洁易用',
		CB11_highlight_2: '低功耗蓝牙实现快速自动连接',
		CB11_highlight_3: '长时间连续佩带，15天的电池续航能力',
		CB11_subtitle: '一款多用',
		CB11_highlight_4: '贴片式传感器配合特制金属电极即可轻松实现钥匙链式手持心电传感器',
		CB12_title: 'CB12',
		CB12_highlight_1: '卡片式手持心律检测传感器',
		app_highlight: '所有传感器均兼容iOS、Android和其它低功耗蓝牙终端',
		Covid19_title: '新型冠状病毒肺炎',
		Covid19_des_01: '越来越多的证据表明，用于治疗新冠患者的药物会导致心电图QT间期延长，从而增加心室颤动的风险而导致心源性猝死。',
		Covid19_des_02: '研究还表明，新型冠状患者的心率变异性显著降低。',
		Covid19_des_03: '小心科技心电监测系统提供精确的QT延长监测和心率变异性分析，包括压力水平和整体心脏健康等重要参数。',
		phone_title: '适用于iOS和Android的可穿戴心电传感器',
		CB11_img_alt: 'CB11手持式显示器正面和背面',
		CB12_img_alt: 'CB12手持式显示器正面和背面',
		phones3_alt: '界面与显示',
		phone_screens_alt: 'QTc测量及心率变异性',
		CB11_patchAdhesive_alt: 'CB11贴片式心律监测传感器'
	},

	CB11: {
		title: 'CB11',
		description: '贴片式心律监测传感器',
		highlight_1: '医用级、长时间连续监测每一次心跳，',
		highlight_1_1: '及时捕捉停搏和房颤等严重心律失常',
		highlight_2: '长达15天的电池续航能力',
		highlight_3: '低功耗蓝牙实现快速自动连接',
		highlight_4: '轻巧依从，简洁易用',
		electronic: '传感器',
		battery: '电池',
		holder: '电极支架',
		electrode : '一次性电极片',
		specification: '技术规格',
		dimension: '尺寸',
		dimension_value: '36.4mm x 36.4mm x 8.2mm',
		weight: '重量（含电池）',
		weight_value: '8.7克',
		range: '心率范围',
		rang_value: '30~240bpm',
		input: '输入动态范围',
		input_value: '±5mV',
		frequency: '频率响应',
		frequency_value: '0.67~40Hz (-3dB)',
		rate: '采样率',
		rate_value: '250Hz',
		battery_type: '电池型号',
		battery_type_value: 'CR2032，DC3V',
		connect: '连接协议',
		connect_value: '低功耗蓝牙',
		electronic_alt: 'CB11心脏监护仪',
		battery_alt: 'CR2032电池',
		holder_alt: '电极座',
		electrode_alt: '一次性电极',
		No_Adhesiv_alt: '贴片式',
		ecordum_logo_alt: 'ecordum图标'
	},

	CB11var: {
		title: 'CB11',
		description: '钥匙链式手持心律检测传感器',
		highlight_1: '医用级、随时随地精准捕捉偶发心律失常',
		highlight_2: '结构紧凑，使用简单',
		highlight_3: '录制30-180秒的心电图',
		highlight_4: '低功耗蓝牙实现快速自动连接',
		highlight_5: '贴片式传感器配合特制金属电极即可',
		highlight_5_1: '轻松实现钥匙链式手持心电检测传感器',
		electronic: '传感器',
		battery: '电池',
		electrode : '金属电极',
		specification: '技术规格',
		dimension: '尺寸',
		dimension_value: '36.4mm x 36.4mm x 8.2mm',
		range: '心率范围',
		rang_value: '30~240bpm',
		input: '输入动态范围',
		input_value: '±5mV',
		frequency: '频率响应',
		frequency_value: '0.67~40Hz (-3dB)',
		rate: '采样率',
		rate_value: '250Hz',
		battery_type: '电池型号',
		battery_type_value: 'CR2032，DC3V',
		connect: '连接协议',
		connect_value: '低功耗蓝牙',
		handheld_front: 'CB11 正面',
		handheld_back: 'CB11 背面'
	},

	CB11Handheld: {
		featuresInfo_1: '医用级、随时随地精准捕捉偶发心律失常',
		featuresInfo_2_1: '结构紧凑，使用简单',
		featuresInfo_2_2: '录制30-180秒的心电图',
		featuresInfo_3: '低功耗蓝牙实现快速自动连接',
		technical_specs: '技术规格',
		specInfo_title_1: '尺寸',
		specInfo_detail_1: '36.4mm x 36.4mm x 8.2mm',
		specInfo_title_2: '重量（含电池）',
		specInfo_detail_2: '8.7克',
		specInfo_title_3: 'Dimensions - Handheld Electrode',
		specInfo_detail_3: '36.1mm x 36.1mm x 4.65mm',
		specInfo_title_4: 'Weight - Handheld Electrode',
		specInfo_detail_4: '4.7g',
		specInfo_title_5: '心率范围',
		specInfo_detail_5: '30~240bpm',
		specInfo_title_6: '输入动态范围',
		specInfo_detail_6: '±5mV',
		specInfo_title_7: '频率响应',
		specInfo_detail_7: '0.67~40Hz (-3dB)',
		specInfo_title_8: '采样率',
		specInfo_detail_8: '250Hz',
		specInfo_title_9: '电池型号',
		specInfo_detail_9: 'CR2032，DC3V',
		specInfo_title_10: '连接协议',
		specInfo_detail_10: '低功耗蓝牙',
		specInfo_title_11: '本地存储',
		specInfo_detail_11: '一小时数据（选项）',
		specInfo_title_12: '三轴加速计',
		specInfo_detail_12: '±2g（选项）'
	},

	CB12: {
		title: 'CB12',
		description: '卡片式手持心律检测传感器',
		highlight_1: '医用级、随时随地精准捕捉偶发心律失常',
		highlight_2: '轻巧便携，上手即测',
		highlight_3: '录制30-180秒的心电图',
		highlight_4: '低功耗蓝牙实现快速自动连接',
		specification: '技术规格',
		technical_specs: '技术规格',
		dimension: '尺寸',
		dimension_value: '91mm x 46mm x 5mm',
		range: '心率范围',
		rang_value: '30~240bpm',
		input: '输入动态范围',
		input_value: '±5mV',
		frequency: '频率响应',
		frequency_value: '0.67~40Hz (-3dB)',
		rate: '采样率',
		rate_value: '250Hz',
		battery_type: '电池型号',
		battery_type_value: 'CR2032，DC3V',
		connect: '连接协议',
		connect_value: '低功耗蓝牙',
		front_alt: 'CB12 正面'
	},

	setting: {
		login: '登录',
		monitors: '传感器',
		contactus: '联系我们',
		product_CB11: 'CB11贴片式',
		product_CB11_var: 'CB11钥匙链式',
		product_CB12: 'CB12卡片式',
		contact_us: '联系我们',
		english: 'ENGLISH',
		first_name: '名字',
		first_name_notice1: '姓名允许使用字母或汉字。',
		first_name_notice2: '名字长度要至少一个字以上。',
		first_name_notice3: '名字长度不能超过十五个字。',
		first_name_notice4: '请输入名字',
		last_name: '姓氏',
		last_name_notice1: '姓氏允许使用字母或汉字。',
		last_name_notice2: '姓氏长度要至少一个字以上。',
		last_name_notice3: '姓氏长度不能超过十五个字。',
		last_name_notice4: '请输入姓氏',
		name: '姓名',
		phone: '电话',
		email: '邮箱',
		email_notice1: '邮件地址无效。',
		email_notice2: '请输入您的邮箱',
		message: '留言',
		message_notice1: '留言不能少于十个字。',
		message_notice2: '请留言',
		required: '必填',
		cancel: '取消',
		send: '发送',
		fail_error: '出现错误，留言未能发送！',
		more: '更多',
		footer1: '美国FDA认证（FDA 510K注册号K222842）',
		footer2: '中国NMPA二类医疗器械认证（鲁械注准20182070327）及生产许可',
		contact: '垂询邮箱：info@eCordum.cn',
		contact1: '微信客服', 
		contact2: '微信公众号',
		copyright: 'Copyright © 2015-2026 小心科技 版权所有',
		caseNumber: '鲁ICP备15044590号-1',
		certificate: '，互联网药品信息服务资格证（鲁）-非经营性-2020-0268',
		English: '中文',
		Chinese: 'English'
	}
};

export default zh;